import { DateTime } from 'luxon';

export const getPregnancyWeek = (timestamp: number, intl: any) => {
  if (timestamp) {
    const dueDate = DateTime.fromMillis(timestamp);
    const diffMilliToDueDate = dueDate.diff(DateTime.now());
    const diffDaysToDueDate = diffMilliToDueDate.valueOf() / 1000 / 24 / 60 / 60;
    const daysSinceConception = 40 * 7 - Math.ceil(diffDaysToDueDate) - 1; // due date = 40 weeks since conception
    const weeks = Math.floor(daysSinceConception / 7);
    const daysLeft = daysSinceConception - weeks * 7;

    if (weeks >= 0) {
      return `${intl.formatMessage({
        id: 'weekAcronymKey'
      })}${weeks}+${daysLeft}${intl.formatMessage({ id: 'dayAcronymKey' })}`;
    } else {
      return intl.formatMessage({ id: 'invalidKey' });
    }
  } else {
    return '--';
  }
};

export const formatSSNForDisplay = (ssn: string) => {
  if (ssn.length === 4) {
    return 'XXX-XX-' + ssn;
  } else return ssn;
};
